import { useCallback, useRef } from "react";

export function useDebounce<F extends (...args: any[]) => void>(fn: F, timeMs: number): F {
  const timeoutId = useRef<any>(null);

  return useCallback(
    ((...args: any[]) => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }

      timeoutId.current = setTimeout(() => {
        fn(...args);
      }, timeMs);
    }) as F,
    [fn, timeMs]
  );
}
